export const inventoryArray = [
        {"img":require('../../images/python.svg').default, "title": "Python" },
        {"img":require('../../images/django.png').default, "title": "Django" },
        {"img":require('../../images/flask.png').default, "title": "Flask" },
        {"img":require('../../images/celery.png').default, "title": "Celery" },
        {"img":require('../../images/logo512.png').default, "title": "React" },
        {"img":require('../../images/jinja.png').default, "title": "Jinja" },
        {"img":require('../../images/html.svg').default, "title": "HTML" },
        {"img":require('../../images/css.svg').default, "title": "CSS" },
        {"img":require('../../images/js.svg').default, "title": "JS" },
        {"img":require('../../images/google_script.svg').default, "title": "GoogleScript" },
        {"img":require('../../images/mongo.svg').default, "title": "MongoDB" },
        {"img":require('../../images/postgress.png').default, "title": "PostgresSQL (ORM)" },
        {"img":require('../../images/sqlite.svg').default, "title": "SQLite (ORM)" },
        {"img":require('../../images/git.svg').default, "title": "GitHub" },
        {"img":require('../../images/tortoise.jpg').default, "title": "TortoiseSVN" },
        {"img":require('../../images/ec2.svg').default, "title": "AWS EC2" },
        {"img":require('../../images/s3.svg').default, "title": "AWS S3" },
        {"img":require('../../images/elastic_beanstalk.png').default, "title": "Elastic Beanstalk" },
        {"img":require('../../images/cloudfront.svg').default, "title": "AWS Cloudfront" },
        {"img":require('../../images/ecs.png').default, "title": "AWS ECS" },
        {"img":require('../../images/sqs.svg').default, "title": "AWS SQS" },
        {"img":require('../../images/route53.svg').default, "title": "AWS Route53" },
        {"img":require('../../images/acm.png').default, "title": "AWS CM" },
        {"img":require('../../images/rds.svg').default, "title": "AWS RDS" },
        {"img":require('../../images/firebase.svg').default, "title": "Firebase" },
        {"img":require('../../images/linux.png').default, "title": "Linux" },
        {"img":require('../../images/docker.png').default, "title": "Docker" },
        {"img":require('../../images/scrapy.png').default, "title": "Scrapy" },
        {"img":require('../../images/selenium.png').default, "title": "Selenium" },
        {"img":require('../../images/pandas.png').default, "title": "Pandas" },
        {"img":require('../../images/tf.png').default, "title": "Tensorflow" },
        {"img":require('../../images/tableau.png').default, "title": "Tableau" },
        {"img":require('../../images/quicksight.svg').default, "title": "AWS Quicksight" },
        {"img":require('../../images/jupyter.png').default, "title": "Jupyter Notebook" },
        {"img":require('../../images/spyder.png').default, "title": "Spyder" },
        {"img":require('../../images/vscode.png').default, "title": "VS Code" },
        {"img":require('../../images/sublime.svg').default, "title": "Sublime" },
        
    ]
;